export default __webpack_public_path__ + "static/media/component003Boss-left.88249075.png";